import { useAuth } from '@features/auth/hooks/useAuth';
import { useUserSettings } from '@features/user/hooks/useUserSettings';
import { UserSettingsMenu } from '@features/user/ui/UserSettingsMenu/UserSettingsMenu';

export function UserSettingsMenuWidget() {
  const { isAuthenticated } = useAuth();
  const settings = useUserSettings();

  return <UserSettingsMenu settings={isAuthenticated ? undefined : settings} />;
}
